var Clearpay = {
    supportedTheme: !1,
    mutationObserver: !1
};
Clearpay.arrayContainsElement = function(e, a) {
    var t;
    if (Array.prototype.indexOf) return e.indexOf(a) > -1;
    for (t = 0; t < e.length; t++)
        if (e[t] == a) return !0;
    return !1
}, Clearpay.closePopup = function(e, a) {
    a.preventDefault(), e("#clearpay-popup-wrapper").hide()
}, Clearpay.commonElements = {
    product: {
        price_selector: ["#ProductPrice", "#product-price", "#ProductSection .product-single__prices", ".product-details .product-price", ".product--container .product-pricing", ".productForm .product-price", ".product-single__meta .product__price", ".product__content .product__price", "p.modal_price", "ul.product-meta", "ul.product-single__meta-list", ".product-single__price", ".product-single__prices", ".product__price"]
    },
    cart: {
        static_page: {
            subtotal_selector: ["#CartSubtotal", "form .subtotal_amount", ".cart__footer .cart__subtotal", ".cart-footer .cart-footer__subtotal", "span.cart__subtotal", ".h1.cart-subtotal--price", ".cart__row--table:last"]
        }
    }
}, Clearpay.extractPriceFromHTML = function(e) {
    var a = e.replace(/[^0-9.]/g, "");
    return Math.round(100 * parseFloat(a))
}, Clearpay.generateCurrencyHTML = function(e) {
    var a = Math.round(e, 2),
        t = clearpay_hide_range_decimals ? a.toFixed(0) : a.toFixed(2);
    return clearpay_show_currency_code ? "£" + t : "£" + t
}, Clearpay.generateInsideLimitHTML = function(e) {
    return e.data("outsidePaymentLimits") && (e.removeData("outsidePaymentLimits"), Clearpay.supportedTheme ? e.find(".clearpay-text1").html("or 4 interest-free instalments of ") : e.find(".clearpay-text1").html("Pay in 4 interest-free instalments of "), e.find(".clearpay-logo").insertAfter(e.find(".clearpay-instalments")), e.find(".clearpay-text2").html(" by ").insertBefore(e.find(".clearpay-logo")), e.find(".clearpay-link-inner").html(clearpay_modal_open_icon ? "ⓘ" : "&#9432;")), e
}, Clearpay.generateInstalmentHTML = function(e) {
    var a = (Math.round(e / 4) / 100).toFixed(2);
    return clearpay_show_currency_code ? "£" + a : "£" + a
}, Clearpay.generateOutsideLimitHTML = function(e) {
    return e.data("outsidePaymentLimits", !0), Clearpay.versionCompare(clearpay_js_snippet_version, "1.0.2", ">=") ? e.find(".clearpay-text1").html("") : e.find(".clearpay-text1").html("Interest-free instalments by "), e.find(".clearpay-logo").insertAfter(e.find(".clearpay-text1")), clearpay_hide_upper_limit && !clearpay_hide_lower_limit ? (e.find(".clearpay-text2").html(" available for orders over "), e.find(".clearpay-instalments").html(Clearpay.generateCurrencyHTML(clearpay_min)).insertAfter(e.find(".clearpay-text2"))) : !clearpay_hide_upper_limit && clearpay_hide_lower_limit ? (e.find(".clearpay-text2").html(" available for orders up to "), e.find(".clearpay-instalments").html(Clearpay.generateCurrencyHTML(clearpay_max)).insertAfter(e.find(".clearpay-text2"))) : (!clearpay_hide_upper_limit && !clearpay_hide_lower_limit || clearpay_hide_upper_limit && clearpay_hide_lower_limit) && (e.find(".clearpay-text2").html(" available between "), e.find(".clearpay-instalments").html(Clearpay.generateCurrencyHTML(clearpay_min) + " - " + Clearpay.generateCurrencyHTML(clearpay_max)).insertAfter(e.find(".clearpay-text2"))), e.find(".clearpay-link-inner").html(clearpay_modal_open_icon ? "ⓘ" : "&#9432;"), e
}, Clearpay.init = function(e) {
    Clearpay.supportedTheme = Clearpay.supportedThemes[clearpay_theme_name.toLowerCase()], Clearpay.mutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    /^\/cart/i.test(window.location.pathname) ? 0 != clearpay_cart_integration_enabled && Clearpay.initStaticCartPage(e) : /^\/(collections|products)/i.test(window.location.pathname) && clearpay_product && clearpay_product_integration_enabled && Clearpay.initProductPage(e), 0 != clearpay_cart_dynamic_integration_enabled && Clearpay.supportedTheme && Clearpay.supportedTheme.hasOwnProperty("cart") && Clearpay.supportedTheme.cart.hasOwnProperty("dynamic_content") && e.each(Clearpay.supportedTheme.cart.dynamic_content, function(a, t) {
        t.hasOwnProperty("target_selector") && t.hasOwnProperty("addedNode_selector") && t.hasOwnProperty("subtotal_selector") && (Clearpay.mutationObserver && new Clearpay.mutationObserver(function(a, r) {
            var c, l;
            for (c = 0; c < a.length; c++)
                if (Clearpay.supportedTheme && e(a[c].target).is(t.target_selector))
                    for (l = 0; l < a[c].addedNodes.length; l++)
                        if ("object" == typeof a[c].addedNodes[l] && e(a[c].addedNodes[l]).is(t.addedNode_selector)) {
                            var p = Clearpay.renderParagraph(e, {
                                total_price: clearpay_cart_total_price,
                                page_name: "dynamic_cart"
                            });
                            p.find(".clearpay-text1").html("or 4 payments of "), p.find(".clearpay-text2").html(" with "), (clearpay_cart_total_price < 100 * clearpay_min || clearpay_cart_total_price > 100 * clearpay_max) && (p = Clearpay.generateOutsideLimitHTML(p)), "undefined" != typeof clearpay_cart_dynamic_css && p.css(clearpay_cart_dynamic_css), e(t.target_selector).find(t.addedNode_selector).find(t.subtotal_selector).after(p), t.paragraph_css && p.css(t.paragraph_css), $logo_element = p.find(".clearpay-logo"), $logo_element.length > 0 && t.logo_css && $logo_element.css(t.logo_css), "function" == typeof t.after_render && t.after_render(e, p)
                        }
        }).observe(document, {
            childList: !0,
            attributes: !1,
            characterData: !1,
            subtree: !0,
            attributeOldValue: !1,
            characterDataOldValue: !1
        }), e(document).ajaxComplete(function(a, r, c) {
            if ("/cart" == c.url) {
                var l = e(r.responseText).find(t.subtotal_selector).find("span.visually-hidden");
                if (l.length > 0) {
                    var p = l.text(),
                        o = Number(p.replace(/[^0-9]/g, ""));
                    clearpay_cart_total_price = o
                }
            } else if ("/cart/change.js" == c.url && 200 == r.status && "OK" == r.statusText) {
                o = r.responseJSON.total_price;
                clearpay_cart_total_price = o
            }
        }))
    })
}, Clearpay.initProductPage = function(e) {
    var a, t = null,
        r = null,
        c = null,
        l = "after";
    a = Clearpay.renderParagraph(e, {
        total_price: clearpay_current_variant.price,
        page_name: "product"
    }), "undefined" != typeof clearpay_product_selector ? (Clearpay.supportedTheme = !0, (t = e(clearpay_product_selector)).length > 0 && (r = t.first())) : (Clearpay.supportedTheme ? e.each(Clearpay.supportedTheme.product, function(c, l) {
        if ((t = e(l.selector)).length > 0) return r = t.first(), l.paragraph_css && a.css(l.paragraph_css), $logo_element = a.find(".clearpay-logo"), $logo_element.length > 0 && l.logo_css && $logo_element.css(l.logo_css), !1
    }) : (t = null, e.each(Clearpay.supportedThemes, function(c, l) {
        if (new RegExp(c, "i").test(clearpay_theme_name) && (e.each(Clearpay.supportedThemes[c].product, function(l, p) {
                if ((t = e(p.selector)).length > 0) return Clearpay.supportedTheme = Clearpay.supportedThemes[c], r = t.first(), p.paragraph_css && a.css(p.paragraph_css), $logo_element = a.find(".clearpay-logo"), $logo_element.length > 0 && p.logo_css && $logo_element.css(p.logo_css), !1
            }), null !== r)) return !1
    })), null === r && e.each(Clearpay.commonElements.product.price_selector, function(a, c) {
        if ((t = e(c)).length > 0) return Clearpay.supportedTheme = !0, r = t.first(), !1
    }), null === r && (t = e('form[action^="/cart/add"]')).length > 0 && (r = t.first(), l = "before", a.find(".clearpay-text1").html("Make 4 interest-free payments of "))), null !== r && (clearpay_current_variant.available ? (clearpay_current_variant.price < 100 * clearpay_min || clearpay_current_variant.price > 100 * clearpay_max) && (a = Clearpay.generateOutsideLimitHTML(a)) : a.hide(), "undefined" != typeof clearpay_product_css && a.css(clearpay_product_css), r[l](a)), 0 != clearpay_variable_price_fallback ? ("undefined" != typeof clearpay_variable_price_fallback_selector && (t = e(clearpay_variable_price_fallback_selector)).length > 0 && (c = t.first()), null === c && null !== r && (c = r), null !== c && (Clearpay.mutationObserver && "mutation" == clearpay_variable_price_fallback_method ? (Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(c.text())), new Clearpay.mutationObserver(function(t, r) {
        var l;
        for (c = e(clearpay_variable_price_fallback_selector).first(), l = 0; l < t.length; l++) e(t[l].target).is(c) && Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(t[l].target.innerHTML))
    }).observe(document.body, {
        childList: !0,
        attributes: !1,
        characterData: !1,
        subtree: !0,
        attributeOldValue: !1,
        characterDataOldValue: !1
    })) : setInterval(function(t) {
        c = e(clearpay_variable_price_fallback_selector).first(), Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(c.text()))
    }, 400))) : e("body").on("change", e('form[action^="/cart/add"]'), function(t) {
        var r = e(t.target).closest("form"),
            c = parseInt(e("input[name=id]:checked, select[name=id], input[name=id], hidden[name=id]", r).val(), 10),
            l = !1;
        !isNaN(c) && c > 0 && e.each(clearpay_product.variants, function(e, t) {
            t.id == c && t.available && (t.price >= 100 * clearpay_min && t.price <= 100 * clearpay_max ? (l = !0, (a = Clearpay.generateInsideLimitHTML(a)).find(".clearpay-instalments").html(Clearpay.generateInstalmentHTML(t.price))) : (l = !0, a = Clearpay.generateOutsideLimitHTML(a)))
        }), r.find("input[type=submit],button[type=submit]").is("[disabled]") && (l = !1), null !== a && (l ? a.show() : a.hide())
    })
}, Clearpay.initStaticCartPage = function(e) {
    var a, t = null,
        r = null,
        c = null,
        l = "after";
    a = Clearpay.renderParagraph(e, {
        total_price: clearpay_cart_total_price,
        page_name: "static_cart"
    }), "undefined" != typeof clearpay_cart_static_selector ? (Clearpay.supportedTheme = !0, (t = e(clearpay_cart_static_selector)).length > 0 && (r = t.first(), a.find(".clearpay-text1").html("or 4 payments of "), a.find(".clearpay-text2").html(" with "))) : (Clearpay.supportedTheme ? e.each(Clearpay.supportedTheme.cart.static_page, function(c, l) {
        if (t = e(l.selector), l.paragraph_css && a.css(l.paragraph_css), t.length > 0) return r = t.first(), a.find(".clearpay-text1").html("or 4 payments of "), a.find(".clearpay-text2").html(" with "), $logo_element = a.find(".clearpay-logo"), $logo_element.length > 0 && l.logo_css && $logo_element.css(l.logo_css), !1
    }) : (t = null, e.each(Clearpay.supportedThemes, function(c, l) {
        if (new RegExp(c, "i").test(clearpay_theme_name) && (e.each(Clearpay.supportedThemes[c].cart.static_page, function(l, p) {
                if (t = e(p.selector), p.paragraph_css && a.css(p.paragraph_css), t.length > 0) return Clearpay.supportedTheme = Clearpay.supportedThemes[c], r = t.first(), a.find(".clearpay-text1").html("or 4 payments of "), a.find(".clearpay-text2").html(" with "), $logo_element = a.find(".clearpay-logo"), $logo_element.length > 0 && p.logo_css && $logo_element.css(p.logo_css), !1
            }), null !== r)) return !1
    })), null === r && e.each(Clearpay.commonElements.cart.static_page.subtotal_selector, function(c, l) {
        if ((t = e(l)).length > 0) return Clearpay.supportedTheme = !0, r = t.first(), a.find(".clearpay-text1").html("or 4 payments of "), a.find(".clearpay-text2").html(" with "), !1
    }), null === r && (a.css({
        "text-align": "right"
    }), a.find(".clearpay-text1").html("Make 4 payments of "), (t = e('a[href="collections/all"],input[name=update]')).length > 0 ? (r = t.first(), l = "before") : (t = e('form[action^="/cart"]:not(form[action^="/cart/add"])')).length > 0 && (r = t.first()))), null !== r && ((clearpay_cart_total_price < 100 * clearpay_min || clearpay_cart_total_price > 100 * clearpay_max) && (a = Clearpay.generateOutsideLimitHTML(a)), "undefined" != typeof clearpay_cart_static_css && a.css(clearpay_cart_static_css), r[l](a)), 0 != clearpay_variable_subtotal_fallback && ("undefined" != typeof clearpay_variable_subtotal_fallback_selector && (t = e(clearpay_variable_subtotal_fallback_selector)).length > 0 && (c = t.first()), null === c && null !== r && (c = r), null !== c && (Clearpay.mutationObserver && "mutation" == clearpay_variable_subtotal_fallback_method ? (Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(c.text())), new Clearpay.mutationObserver(function(t, r) {
        var l;
        for (c = e(clearpay_variable_subtotal_fallback_selector).first(), l = 0; l < t.length; l++) e(t[l].target).is(c) && Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(t[l].target.innerHTML))
    }).observe(c.get(0), {
        childList: !0,
        attributes: !1,
        characterData: !1,
        subtree: !0,
        attributeOldValue: !1,
        characterDataOldValue: !1
    })) : setInterval(function(t) {
        c = e(clearpay_variable_subtotal_fallback_selector).first(), Clearpay.updateParagraph(a, Clearpay.extractPriceFromHTML(c.text()))
    }, 400)))
}, Clearpay.launchPopup = function(e, a) {
    a.preventDefault();
    var t, r, c, l, p;
    (t = e("#clearpay-popup-wrapper")).length > 0 ? t.show() : (t = e(document.createElement("div")).attr("id", "clearpay-popup-wrapper").css({
        position: "fixed",
        "z-index": 9999999999,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        overflow: "auto"
    }).appendTo("body").on("click", function(a) {
        Clearpay.closePopup(e, a)
    }), r = e(document.createElement("div")).attr("id", "clearpay-popup-outer").css({
        display: "-ms-flexbox",
        display: "-webkit-flex",
        display: "flex",
        "-webkit-justify-content": "center",
        "-ms-flex-pack": "center",
        "justify-content": "center",
        "-webkit-align-content": "center",
        "-ms-flex-line-pack": "center",
        "align-content": "center",
        "-webkit-align-items": "center",
        "-ms-flex-align": "center",
        "align-items": "center",
        width: "100%",
        "min-height": "100%",
        "background-color": "rgba(0, 0, 0, 0.80)"
    }).appendTo(t), c = e(document.createElement("div")).attr("id", "clearpay-popup-inner").css({
        position: "relative",
        "background-color": "#fff"
    }).appendTo(r), (l = e(document.createElement("a"))).attr("href", "https://www.clearpay.co.uk/terms"), l.attr("target", "_blank").css({
        display: "block"
    }).appendTo(c), p = e(document.createElement("img")), e(window).width() > 640 ? p.attr("src", "https://static.afterpay.com/clearpay-lightbox-desktop.png").attr("srcset", "https://static.afterpay.com/clearpay-lightbox-desktop.png 1x, https://static.afterpay.com/clearpay-lightbox-desktop@2x.png 2x").css({
        "max-width": "597px"
    }) : p.attr("src", "https://static.afterpay.com/clearpay-lightbox-mobile.png").attr("srcset", "https://static.afterpay.com/clearpay-lightbox-mobile.png 1x, https://static.afterpay.com/clearpay-lightbox-mobile@2x.png 2x").css({
        "max-width": "300px"
    }), p.css({
        display: "block",
        width: "100%"
    }).appendTo(l).on("click", function(e) {
        e.stopPropagation()
    }), e(document.createElement("a")).attr("href", "#").css({
        position: "absolute",
        right: "8px",
        top: "8px"
    }).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="32px" height="32px"><g id="surface1"><path style=" " d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z "/></g></svg>').appendTo(c).on("click", function(a) {
        Clearpay.closePopup(e, a)
    }))
}, Clearpay.loadScript = function(e, a) {
    var t = document.createElement("script");
    t.type = "text/javascript", t.readyState ? t.onreadystatechange = function() {
        "loaded" != t.readyState && "complete" != t.readyState || (t.onreadystatechange = null, a())
    } : t.onload = function() {
        a()
    }, t.src = e, document.getElementsByTagName("head")[0].appendChild(t)
}, Clearpay.renderParagraph = function(e, a) {
    var t = e(document.createElement("p")).addClass("clearpay-paragraph");
    null !== clearpay_product && t.attr("data-product-id", clearpay_product.id);
    e(document.createElement("span")).addClass("clearpay-text1").appendTo(t).html("or make 4 interest-free payments of ");
    e(document.createElement("strong")).addClass("clearpay-instalments").html(Clearpay.generateInstalmentHTML(a.total_price)).appendTo(t);
    e(document.createElement("span")).addClass("clearpay-text2").appendTo(t).html(" with ");
    var r = clearpay_logo_theme;
    "product" == a.page_name && "undefined" != typeof clearpay_product_logo_theme ? r = clearpay_product_logo_theme : "static_cart" == a.page_name && "undefined" != typeof clearpay_cart_static_logo_theme ? r = clearpay_cart_static_logo_theme : "dynamic_cart" == a.page_name && "undefined" != typeof clearpay_cart_dynamic_logo_theme && (r = clearpay_cart_dynamic_logo_theme);
    e(document.createElement("img")).addClass("clearpay-logo").css({
        "vertical-align": "middle",
        width: "110px",
        border: "0px"
    }).attr("src", "https://static.afterpay.com/integration/product-page/logo-clearpay-" + r + ".png").attr("srcset", "https://static.afterpay.com/integration/product-page/logo-clearpay-" + r + ".png 1x, https://static.afterpay.com/integration/product-page/logo-clearpay-" + r + "@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-clearpay-" + r + "@3x.png 3x").attr("width", "110").attr("height", "21").attr("alt", "Clearpay").appendTo(t), e(document.createElement("span")).addClass("clearpay-text3").html("&nbsp;").appendTo(t);
    var c = e(document.createElement("a")).addClass("clearpay-link");
    c.attr("href", "https://www.clearpay.co.uk/terms"), c.attr("target", "_blank").on("click", function(a) {
        Clearpay.launchPopup(e, a)
    }).appendTo(t);
    e(document.createElement("u")).addClass("clearpay-link-inner").css({
        "font-size": "12px"
    }).html(clearpay_modal_open_icon ? "ⓘ" : "&#9432;").css(clearpay_modal_open_icon ? {
        "text-decoration": "none"
    } : {
        "text-decoration": "underline"
    }).appendTo(c);
    return t
}, Clearpay.supportedCurrencies = ["GBP"], Clearpay.supportedThemes = {
    alchemy: {
        product: {
            "2017-12-14": {
                selector: ".quadd-wrapper"
            }
        }
    },
    atlantic: {
        product: {
            "2017-12-14": {
                selector: "p.price"
            }
        }
    },
    blockshop: {
        product: {
            "2017-12-14": {
                selector: "article .prices",
                paragraph_css: {
                    "margin-top": "-1em",
                    "margin-bottom": "2em"
                }
            }
        }
    },
    boundless: {
        product: {
            "2017-12-14": {
                selector: "#AddToCartForm-product-template .product__price",
                paragraph_css: {
                    "margin-top": "-20px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: "span.cart__subtotal"
                }
            }
        }
    },
    brooklyn: {
        product: {
            "2017-12-14": {
                selector: "#ProductPrice",
                logo_css: {
                    border: "0px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".cart__row--table:last",
                    logo_css: {
                        border: "0px"
                    }
                }
            },
            dynamic_content: {
                "2018-06-25": {
                    target_selector: "#CartDrawer #CartContainer",
                    addedNode_selector: "form.ajaxcart",
                    subtotal_selector: ".ajaxcart__footer .grid--full",
                    paragraph_css: {
                        "text-align": "right"
                    },
                    logo_css: {
                        border: "0px"
                    },
                    after_render: function(e, a) {
                        var t = e("#CartContainer .ajaxcart__inner--has-fixed-footer"),
                            r = e("#CartContainer .ajaxcart__footer--fixed"),
                            c = r.outerHeight() + a.outerHeight(!0);
                        t.css("bottom", c + "px"), r.css("height", c + "px")
                    }
                }
            }
        }
    },
    classic: {
        product: {
            "2017-12-14": {
                selector: ".product-single__prices",
                paragraph_css: {
                    "margin-top": "-15px",
                    "margin-bottom": "30px"
                }
            }
        }
    },
    debut: {
        product: {
            "2017-12-14": {
                selector: ".product-single__price",
                paragraph_css: {
                    "margin-top": "-20px",
                    "margin-bottom": "40px"
                }
            },
            "2018-07-04": {
                selector: ".product__price",
                paragraph_css: {
                    "margin-top": "-10px",
                    "margin-bottom": "40px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".cart__footer .cart__subtotal"
                }
            }
        }
    },
    district: {
        product: {
            "2017-12-14": {
                selector: "#ComparePrice-product-template",
                paragraph_css: {
                    "margin-top": "0.3rem",
                    display: "block",
                    "font-style": "normal"
                }
            }
        }
    },
    empire: {
        product: {
            "2017-12-14": {
                selector: ".product--container .product-pricing",
                paragraph_css: {
                    "line-height": "1.5",
                    "margin-top": "10px",
                    "margin-bottom": "22px"
                }
            }
        }
    },
    fashionopolism: {
        product: {
            "2017-12-14": {
                selector: ".product-prices"
            },
            "2018-08-10": {
                selector: "#product-price"
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#basket-right>h4"
                }
            }
        }
    },
    flow: {
        product: {
            "2017-12-14": {
                selector: "#ProductPrice",
                paragraph_css: {
                    "margin-top": "-20px",
                    "margin-bottom": "30px"
                }
            }
        }
    },
    grid: {
        product: {
            "2017-12-14": {
                selector: ".product-details .product-price",
                paragraph_css: {
                    "margin-top": "-35px",
                    "margin-bottom": "40px"
                }
            }
        }
    },
    icon: {
        product: {
            "2017-12-14": {
                selector: "#product-price",
                paragraph_css: {
                    "margin-top": "-20px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#basket-right>h4"
                }
            }
        }
    },
    jumpstart: {
        product: {
            "2017-12-14": {
                selector: "#AddToCartForm .price:last"
            },
            "2018-05-30": {
                selector: "#ProductPrice-product-template"
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: "span.h3.cart__subtotal"
                }
            }
        }
    },
    minimal: {
        product: {
            "2017-12-14": {
                selector: ".product-single__prices",
                paragraph_css: {
                    "margin-top": "-15px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".h5.cart__subtotal"
                }
            }
        }
    },
    modular: {
        product: {
            "2017-12-14": {
                selector: ".productForm .product-price",
                paragraph_css: {
                    "margin-top": "-1rem",
                    "margin-bottom": "1.5rem"
                }
            }
        }
    },
    motion: {
        product: {
            "2017-12-14": {
                selector: ".product-single__meta .product__price:last"
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".grid--full.cart__row--table:last",
                    paragraph_css: {
                        "margin-top": "10px"
                    }
                }
            }
        }
    },
    narrative: {
        product: {
            "2017-12-14": {
                selector: ".product__content .product__price",
                paragraph_css: {
                    "margin-top": "-10px",
                    "text-align": "center"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".cart-footer .cart-footer__subtotal"
                }
            }
        }
    },
    pacific: {
        product: {
            "2017-12-14": {
                selector: ".product-price"
            }
        }
    },
    parallax: {
        product: {
            "2017-12-14": {
                selector: ".modal_price"
            }
        },
        cart: {
            static_page: {
                "2018-05-31": {
                    selector: "form .subtotal_amount",
                    paragraph_css: {
                        "font-size": "13px"
                    }
                }
            }
        }
    },
    pipeline: {
        product: {
            "2017-12-14": {
                selector: "#ComparePriceWrapper-product",
                paragraph_css: {
                    "margin-top": "15px",
                    "line-height": "1.5",
                    "letter-spacing": "0",
                    "font-size": "14px",
                    "text-transform": "none",
                    color: "#000"
                }
            },
            "2018-08-10": {
                selector: "#productInfo-product .product__price"
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: ".cart__footer__text:first"
                }
            }
        }
    },
    pop: {
        product: {
            "2017-12-14": {
                selector: ".product-single__price"
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: "span.cart__subtotal"
                }
            }
        }
    },
    prestige: {
        product: {
            "2018-07-27": {
                selector: ".ProductMeta__PriceList.Heading"
            }
        }
    },
    providence: {
        product: {
            "2017-12-14": {
                selector: ".pricing"
            }
        }
    },
    retina: {
        product: {
            "2017-12-14": {
                selector: ".modal_price",
                paragraph_css: {
                    "margin-top": "-15px",
                    "margin-bottom": "20px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#cart_form .subtotal_amount",
                    paragraph_css: {
                        "font-size": "13px"
                    }
                }
            }
        }
    },
    showcase: {
        product: {
            "2018-08-10": {
                selector: ".product-detail__title-and-price .price-area"
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#cartform .subtotal"
                }
            }
        }
    },
    showtime: {
        product: {
            "2017-12-14": {
                selector: ".desc_blk_bot .price",
                paragraph_css: {
                    float: "none",
                    clear: "both",
                    "margin-bottom": "1rem",
                    "text-align": "center"
                }
            }
        }
    },
    simple: {
        product: {
            "2017-12-14": {
                selector: "#ProductSection .product-single__prices",
                paragraph_css: {
                    "margin-top": "-15px",
                    "margin-bottom": "30px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: "span.cart__subtotal.h3"
                }
            }
        }
    },
    supply: {
        product: {
            "2017-12-14": {
                selector: "ul.product-meta"
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: ".h1.cart-subtotal--price"
                }
            },
            dynamic_content: {
                "2018-05-30": {
                    target_selector: "#ajaxifyCart.ajaxifyCart--content",
                    addedNode_selector: "form.cart-form",
                    subtotal_selector: ".h1.cart-subtotal--price"
                }
            }
        }
    },
    symmetry: {
        product: {
            "2017-12-14": {
                selector: "#main-product-detail .price-area"
            }
        }
    },
    testament: {
        product: {
            "2017-12-14": {
                selector: "#product-price"
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#basket-right>h4"
                }
            }
        }
    },
    turbo: {
        product: {
            "2018-08-10": {
                selector: ".modal_price"
            }
        },
        cart: {
            static_page: {
                "2018-08-10": {
                    selector: "#cart_form .cart_subtotal"
                }
            }
        }
    },
    venture: {
        product: {
            "2017-12-14": {
                selector: "ul.product-single__meta-list",
                paragraph_css: {
                    "margin-top": "10px"
                }
            }
        },
        cart: {
            static_page: {
                "2018-05-30": {
                    selector: "p#CartSubtotal"
                }
            }
        }
    },
    venue: {
        product: {
            "2017-12-14": {
                selector: "h3.product-single__price-text",
                paragraph_css: {
                    "line-height": "1.5"
                }
            }
        }
    }
}, Clearpay.updateParagraph = function(e, a) {
    a >= 100 * clearpay_min && a <= 100 * clearpay_max ? (e.show(), (e = Clearpay.generateInsideLimitHTML(e)).find(".clearpay-instalments").html(Clearpay.generateInstalmentHTML(a))) : (e.show(), e = Clearpay.generateOutsideLimitHTML(e))
}, Clearpay.versionCompare = function(e, a, t) {
    var r, c, l = 0,
        p = {
            dev: -6,
            alpha: -5,
            a: -5,
            beta: -4,
            b: -4,
            RC: -3,
            rc: -3,
            "#": -2,
            p: 1,
            pl: 1
        },
        o = function(e) {
            return e = ("" + e).replace(/[_\-+]/g, "."), (e = e.replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, ".")).length ? e.split(".") : [-8]
        },
        i = function(e) {
            return e ? isNaN(e) ? p[e] || -7 : parseInt(e, 10) : 0
        };
    for (e = o(e), a = o(a), c = Math.max(e.length, a.length), r = 0; r < c; r++)
        if (e[r] !== a[r]) {
            if (e[r] = i(e[r]), a[r] = i(a[r]), e[r] < a[r]) {
                l = -1;
                break
            }
            if (e[r] > a[r]) {
                l = 1;
                break
            }
        } if (!t) return l;
    switch (t) {
        case ">":
        case "gt":
            return l > 0;
        case ">=":
        case "ge":
            return l >= 0;
        case "<=":
        case "le":
            return l <= 0;
        case "===":
        case "=":
        case "eq":
            return 0 === l;
        case "<>":
        case "!==":
        case "ne":
            return 0 !== l;
        case "":
        case "<":
        case "lt":
            return l < 0;
        default:
            return null
    }
};
var clearpay_js_include_version = "1.6.0";
if (void 0 === clearpay_product_integration_enabled) var clearpay_product_integration_enabled = !0;
if (void 0 === clearpay_cart_integration_enabled) var clearpay_cart_integration_enabled = !0;
if (void 0 === clearpay_cart_dynamic_integration_enabled) var clearpay_cart_dynamic_integration_enabled = !1;
if (void 0 === clearpay_variable_price_fallback)
    if ("undefined" == typeof clearpay_variable_price_fallback_selector) var clearpay_variable_price_fallback = !1;
    else clearpay_variable_price_fallback = !0;
if ("undefined" == typeof clearpay_variable_price_fallback_method && (clearpay_variable_price_fallback_method = "mutation"), void 0 === clearpay_variable_subtotal_fallback)
    if ("undefined" == typeof clearpay_variable_subtotal_fallback_selector) var clearpay_variable_subtotal_fallback = !1;
    else clearpay_variable_subtotal_fallback = !0;
if ("undefined" == typeof clearpay_variable_subtotal_fallback_method && (clearpay_variable_subtotal_fallback_method = "mutation"), void 0 === clearpay_modal_responsive) var clearpay_modal_responsive = !1;
if (void 0 === clearpay_show_currency_code) var clearpay_show_currency_code = !0;
if (void 0 === clearpay_hide_range_decimals)
    if (Clearpay.versionCompare(clearpay_js_snippet_version, "1.0.2", ">=")) var clearpay_hide_range_decimals = !0;
    else clearpay_hide_range_decimals = !1;
if (void 0 === clearpay_hide_upper_limit) var clearpay_hide_upper_limit = !1;
if (void 0 === clearpay_hide_lower_limit) var clearpay_hide_lower_limit = !1;
if (void 0 === clearpay_modal_open_icon) var clearpay_modal_open_icon = !1;
if (void 0 === clearpay_min) var clearpay_min = .04;
if (void 0 === clearpay_max) var clearpay_max = 800;
if (clearpay_min = Math.max(clearpay_min, 10), void 0 === clearpay_logo_theme) var clearpay_logo_theme = "colour";
Clearpay.arrayContainsElement(Clearpay.supportedCurrencies, clearpay_shop_currency) && ("function" != typeof jQuery || !Object.prototype.hasOwnProperty.call(jQuery, "fn") || Clearpay.versionCompare(jQuery.fn.jquery, "1.7", "<") ? Clearpay.loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js", function() {
    Clearpay.jQuery_1_12_4 = jQuery.noConflict(!0), Clearpay.init(Clearpay.jQuery_1_12_4)
}) : Clearpay.init(jQuery));